'use strict';

import React from 'react';

//require('styles//Followmouse.scss');

class FollowmouseComponent extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			rotation: 0,
			x: 0,
			y: 0,
			boundingClientRect: {}
		}
	}

	componentDidMount(){
		this.setState({
			boundingClientRect: this.refs.follow.getBoundingClientRect()
		})

		document.body.addEventListener("mousemove", (e) => {
			this.handleMousemove(e)
		}, false)

		document.body.addEventListener("touchmove", (e) => {
			this.handleTouchmove(e)
		}, true)

	}

	handleMousemove(event){
	    var x = event.clientX;
	    var y = event.clientY;
	    this.rotate(x, y);
	}

	handleTouchmove(event){
	    event.preventDefault(); // we don't want to scroll
	    var touch = event.touches[0];
	    var x = touch.clientX;
	    var y = touch.clientY;
	    this.rotate(x, y);
	}

	rotate(x, y){
		//console.log(x,y,this.refs.follow)
		const width = this.state.boundingClientRect.width / 2;
		const height = this.state.boundingClientRect.height / 2;

		const centerX = this.state.boundingClientRect.x + width;
		const centerY = this.state.boundingClientRect.y + height;

		const diffX = x - centerX;
		const diffY = y - centerY;

		const radians = Math.atan2(diffX, diffY);
		const degree = (radians * (180 / Math.PI) * -1) + 90; 
		
		this.setState({
			rotation: degree
		})
	}

	render() {
		const {texte} = this.props
		const style = {
			transform: "rotate("+this.state.rotation+"deg)",
			WebkitTransform: "rotate("+this.state.rotation+"deg)"
		}
		return (
			<div 
			className="followmouse-component" 
			ref="follow"
			style={style} >
        		<span>{texte}</span>
        	</div>
        );
    }
}

FollowmouseComponent.displayName = 'FollowmouseComponent';

// Uncomment properties you need
// FollowmouseComponent.propTypes = {};
// FollowmouseComponent.defaultProps = {};

export default FollowmouseComponent;



// WEBPACK FOOTER //
// ./src/components/FollowmouseComponent.js